export function normalizeSuggestedAreaCode(value) {
  if (value == null) {
    return ""
  }
  const digits = String(value).replace(/\D/g, "").slice(0, 3)
  return digits.length === 3 ? digits : ""
}

/**
 * Decide the area-code field value after a profile/account update.
 * Automatic detection only seeds the initial selection; a manual edit is kept
 * until the active parent account changes.
 */
export function nextAreaCodeSelection({
  accountId,
  lastAccountId,
  suggestedAreaCode,
  currentAreaCode,
  userHasEdited,
}) {
  const suggested = normalizeSuggestedAreaCode(suggestedAreaCode)

  if (accountId !== lastAccountId) {
    return {
      areaCode: suggested,
      lastAccountId: accountId ?? null,
      userHasEdited: false,
    }
  }

  if (!userHasEdited && suggested && !currentAreaCode) {
    return {
      areaCode: suggested,
      lastAccountId,
      userHasEdited: false,
    }
  }

  return {
    areaCode: currentAreaCode,
    lastAccountId,
    userHasEdited,
  }
}
